import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChatConversation } from './ChatConversation';
import { useEmergencyMode } from './useEmergencyMode';
import styles from './ChatbotModal.module.css';

export function ChatbotModal({ onClose }) {
  const navigate = useNavigate();
  const emergency = useEmergencyMode();

  // 모바일 풀스크린 상태일 때 background scroll 잠금 (≤640px)
  useEffect(() => {
    const mql = window.matchMedia('(max-width: 640px)');
    if (!mql.matches) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return (
    <div
      className={`${styles.modal} ${emergency ? styles.modalEmergency : ''}`}
      role="dialog"
      aria-label="메디로이어 상담"
    >
      <header className={styles.header}>
        <div className={styles.headerLeft}>
          <div className={styles.avatar} aria-hidden="true">
            M
          </div>
          <div className={styles.headerText}>
            <div className={styles.title}>
              {emergency ? '메디로이어 야간 응급 상담' : '메디로이어 상담'}
            </div>
            <div className={styles.status}>
              <span className={`${styles.statusDot} ${emergency ? styles.statusDotAlert : ''}`} />
              {emergency ? '담당 변호사에게 즉시 전달' : '담당자 직접 상담 · 평일 09–21시'}
            </div>
          </div>
        </div>
        <div className={styles.headerActions}>
          <button
            type="button"
            className={styles.iconBtn}
            onClick={() => {
              onClose();
              navigate('/chat');
            }}
            aria-label="전체 화면으로 보기"
          >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path
                d="M3 6.5V3h3.5M13 6.5V3H9.5M3 9.5V13h3.5M13 9.5V13H9.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <button type="button" className={styles.iconBtn} onClick={onClose} aria-label="닫기">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path
                d="M4 4l8 8M12 4l-8 8"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>
      </header>
      <ChatConversation variant="modal" />
    </div>
  );
}
